import { derived, writable } from 'svelte/store';
const tmemStateWritable = writable({
    stem: true,
    mode: "MUST",
    page: 1,
    includedAuthors: [],
    excludedAuthors: [],
    stemOrModeChanged: false
});
export const tmemState = derived(tmemStateWritable, (state) => state);
export function setInitial(includedAuthors, excludedAuthors, stem) {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { includedAuthors, excludedAuthors, stem })));
}
export function setTmemMode(mode) {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { mode: mode, page: 1, stemOrModeChanged: true })));
}
export function resetAuthorFilter() {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { includedAuthors: [], excludedAuthors: [], stemOrModeChanged: true })));
}
export function updateTmemStem(stem) {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { stem: stem, page: 1, stemOrModeChanged: true })));
}
export function updateTmemState({ stem, mode }) {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { stem: stem || currentState.stem, mode: mode || currentState.mode, page: 1, stemOrModeChanged: true })));
}
export function toggleExcludeAuthor(authorToExclude) {
    tmemStateWritable.update(currentState => {
        const newExcludedAuthors = [...currentState.excludedAuthors.filter(author => author.id !== authorToExclude.id)];
        const newIncludedAuthors = [...currentState.includedAuthors.filter(author => author.id !== authorToExclude.id)];
        if (newExcludedAuthors.length === currentState.excludedAuthors.length) {
            // author not currently excluded
            newExcludedAuthors.push(authorToExclude);
        }
        return Object.assign(Object.assign({}, currentState), { includedAuthors: newIncludedAuthors, excludedAuthors: newExcludedAuthors, page: 1, stemOrModeChanged: true });
    });
}
export function toggleIncludeAuthor(authorToInclude) {
    tmemStateWritable.update(currentState => {
        const newIncludedAuthors = [...currentState.includedAuthors.filter(author => author.id !== authorToInclude.id)];
        if (newIncludedAuthors.length === currentState.includedAuthors.length) {
            newIncludedAuthors.push(authorToInclude);
        }
        return Object.assign(Object.assign({}, currentState), { includedAuthors: newIncludedAuthors, excludedAuthors: [], page: 1, stemOrModeChanged: true });
    });
}
export function loadNextPage() {
    tmemStateWritable.update(currentState => (Object.assign(Object.assign({}, currentState), { page: currentState.page + 1 })));
}
